export default [{
  path: '/chargedocuments/view',
  name: 'chargedocuments',
  component: () => import('@/app/charge-document/ChargeDocumentView'),
  meta: {

  }
}]
